export const DateMixin = {
    methods: {
        formatDateTime(dateStr) {
            let date = new Date(dateStr);
            return `${date.toLocaleDateString()} - ${date.toLocaleTimeString()}`;
        }
    }
}